// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Belt_Float = require("rescript/lib/js/belt_Float.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.bs.js");

function strToBool(str) {
  switch (str) {
    case "false" :
        return false;
    case "true" :
        return true;
    default:
      return ;
  }
}

function locStorWriteString(key, str) {
  localStorage.setItem(key, str);
}

function locStorReadString(key) {
  return Caml_option.null_to_opt(localStorage.getItem(key));
}

function locStorWriteBool(key, bool) {
  localStorage.setItem(key, Expln_utils_common.stringify(bool));
}

function locStorReadBool(key) {
  return Belt_Option.flatMap(Caml_option.null_to_opt(localStorage.getItem(key)), strToBool);
}

function locStorWriteInt(key, $$int) {
  localStorage.setItem(key, String($$int));
}

function locStorReadInt(key) {
  return Belt_Option.flatMap(Caml_option.null_to_opt(localStorage.getItem(key)), Belt_Int.fromString);
}

function locStorWriteFloat(key, fl) {
  localStorage.setItem(key, String(fl));
}

function locStorReadFloat(key) {
  return Belt_Option.flatMap(Caml_option.null_to_opt(localStorage.getItem(key)), Belt_Float.fromString);
}

function useStateFromLocalStorage(key, fromString, toString) {
  var match = React.useState(function () {
        return Curry._1(fromString, Caml_option.null_to_opt(localStorage.getItem(key)));
      });
  var setValuePriv = match[1];
  var setValue = function (mapper) {
    Curry._1(setValuePriv, (function (old) {
            var $$new = Curry._1(mapper, old);
            locStorWriteString(key, Curry._1(toString, $$new));
            return $$new;
          }));
  };
  return [
          match[0],
          setValue
        ];
}

function useStateFromLocalStorageBool(key, $$default) {
  return useStateFromLocalStorage(key, (function (boolStrOpt) {
                if (boolStrOpt === undefined) {
                  return $$default;
                }
                switch (boolStrOpt) {
                  case "false" :
                      return false;
                  case "true" :
                      return true;
                  default:
                    return $$default;
                }
              }), Expln_utils_common.stringify);
}

function useStateFromLocalStorageStr(key, $$default) {
  return useStateFromLocalStorage(key, (function (strOpt) {
                if (strOpt !== undefined) {
                  return strOpt;
                } else {
                  return $$default;
                }
              }), (function (str) {
                return str;
              }));
}

function useStateFromLocalStorageInt(key, $$default) {
  return useStateFromLocalStorage(key, (function (strOpt) {
                if (strOpt !== undefined) {
                  return Belt_Option.getWithDefault(Belt_Int.fromString(strOpt), $$default);
                } else {
                  return $$default;
                }
              }), (function (prim) {
                return String(prim);
              }));
}

exports.locStorWriteString = locStorWriteString;
exports.locStorReadString = locStorReadString;
exports.locStorWriteBool = locStorWriteBool;
exports.locStorReadBool = locStorReadBool;
exports.locStorWriteInt = locStorWriteInt;
exports.locStorReadInt = locStorReadInt;
exports.locStorWriteFloat = locStorWriteFloat;
exports.locStorReadFloat = locStorReadFloat;
exports.useStateFromLocalStorage = useStateFromLocalStorage;
exports.useStateFromLocalStorageBool = useStateFromLocalStorageBool;
exports.useStateFromLocalStorageStr = useStateFromLocalStorageStr;
exports.useStateFromLocalStorageInt = useStateFromLocalStorageInt;
/* react Not a pure module */
